import dayjs from 'dayjs'
import { getLocaleMarket } from './getLocaleMarket'

export const getSortedOffers = offers => {
  const myMarket = getLocaleMarket()
  const displayConditionChecked = myMarket ? myMarket.isLoyaltyMarket : true

  const classifiedOffers = offers.map(offer => {
    const isAppExclusive = offer.promotion === 'ZC01'
    const isAppCombined =
      offer.promotion === 'ZC00' &&
      dayjs(offer.appValidto).isSameOrAfter(dayjs(), 'day') &&
      displayConditionChecked

    return { ...offer, isAppExclusive, isAppCombined }
  })

  const filteredOffers = displayConditionChecked
    ? classifiedOffers
    : classifiedOffers.filter(offer => !offer.isAppExclusive)

  return filteredOffers.sort(
    (a, b) =>
      (b.isAppCombined ? 2 : b.isAppExclusive ? 1 : 0) -
      (a.isAppCombined ? 2 : a.isAppExclusive ? 1 : 0)
  )
}
